// src/components/pages/Pessoa/profile/resolvePessoaProfile.js

import { pessoaProfiles } from './pessoaProfiles';

export function resolvePessoaProfile(tipo) {
    if (!tipo) return pessoaProfiles.pessoa;
    return pessoaProfiles[tipo] || pessoaProfiles.pessoa;
}
